/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "react-bootstrap-accordion/dist/index.css";
import { ToastContainer, toast } from "react-toastify";
import ContentLoader from "react-content-loader";
import axios from "axios";
import moment from "moment";
import { Tooltip as ReactTippy } from "react-tippy";
import "react-tippy/dist/tippy.css";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  BarChart,
  Bar,
  PieChart,
  Pie,
} from "recharts";
import WidgetsIcon from "@material-ui/icons/Widgets";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import PendingContracts from "../dashboard/componets/PendingContracts";
import InvoicesDue from "../dashboard/componets/InvoicesDue";
import Contractsdashboard from "../dashboard/componets/Contractsdashboard";
import UnappliedPayments from "../dashboard/componets/UnappliedPayments";
import { getTrans as t } from "../../Localization/translations";
import Helper from "../../Helper";
import { tr } from "date-fns/locale";

function Dashboard({ customerPermission }) {
  const [contracts, setContracts] = useState("");
  const [unappliedpayments, setUnappliedpayments] = useState("");
  const [tableData, setTableData] = useState([]);
  const [receipts, setReceipts] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [items, setItems] = useState([]);
  const [graphcontract, setGraphContract] = useState([]);
  const [datacategory, setDatacategory] = useState([]);
  const [graphreceipt, setGraphReceipt] = useState([]);
  const [graphaging, setGraphaging] = useState([]);
  const [graphinterest_rate_data, setGraphinterest_rate_data] = useState([]);
  const [activecontract, setActiveContract] = useState([]);
  const [pendingcon, setPendingcontract] = useState([]);
  const [unappliedreceipt, setUnappliedreceipt] = useState([]);
  const [invoicess, setInvoicess] = useState([]);
  const [widgetData, setWidgetData] = useState();
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(
    localStorage.getItem("expandedItem") ||
      (tableData && tableData.length > 0 ? tableData[0].key : null)
  );
  const [value, setValue] = useState({
    AmountFinanced: "",
    PendingContracts: "",
    AmountDue: "",
    PaymentsApplied: "",
    unappliedPayments: "",
    netInvestment: "",
    // averageLeaseTerm: "",
    averageOriginalTerm: "",
    averageRemainingTerm: "",
    endofLeaseAssetValue: "",
  });
  const [checkbox, setCheckbox] = useState([
    "Amount Financed",
    "Pending Contracts",
    "Amount Due",
    "Payments Applied",
    "Unapplied Payments",
    "Net Investment",
    // "Average Lease Term",
    "End of Lease Asset Value",
    "Average Term Original",
    "Average Term Remaining",
  ]);

  const [amount, setamount] = useState([]);
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  //chart
  const [charts, setCharts] = useState([]);
  const [isContractsChecked, setIsContractsChecked] = useState(false);
  const [isReceiptsChecked, setIsReceiptsChecked] = useState(false);
  const [isDelinquencyAging, setIsDelinquencyAging] = useState(false);
  const [isleaseRevenueandProfitability, setIsLeaseRevenueandProfitability] =
    useState(false);
  const [piechart, setPiechart] = useState(false);

  const [isPendingcontracts, setIsPendingcontracts] = useState(false);
  const [isinvoicesDue, setIsInvoicesDue] = useState(false);
  const [iscontract, setIsContract] = useState(false);
  const [isUnappliedPayments, setIsUnappliedPayments] = useState(false);
  const permissionsArray = permissionss.split(",");
  const [orderNo, setOrderNo] = useState(0);

  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedDashboard, setSelectedDashboard] = useState("Command Center");
  const _dashboardCacheTime = useRef(null);

  const handelDefault = () => {
    const CACHE_MS = 5 * 60 * 1000; // 5 minutes
    if (_dashboardCacheTime.current && Date.now() - _dashboardCacheTime.current < CACHE_MS) {
      return;
    }
    _dashboardCacheTime.current = Date.now();
    let url = API + "helper/dashboard/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setamount(response.data);
      setItems(response.data.amountfinaced);
      setContracts(response.data.pendingcontracts);
      setInvoices(response.data.Amountdue);
      setReceipts(response.data.PaymentsApplied);
      setGraphContract(response.data.graphContract);
      setGraphReceipt(response.data.graphReceipt);
      const processedData =
        response.data.category_wise_subcategories &&
        response.data.category_wise_subcategories.map((category) => {
          if (category.percentage === 0) {
            return {
              ...category,
              displayName: category.name,
              name: "Not Found",
              isZero: true,
              value: 1,
            };
          }
          return {
            ...category,
            displayName: category.name,
            isZero: false,
            value: category.total_value,
          };
        });

      setDatacategory(processedData ? processedData : []);

      const firstNonZeroIndex = response.data.category_wise_subcategories
        ? response.data.category_wise_subcategories.findIndex(
            (cat) => cat.percentage > 0
          )
        : -1;
      if (firstNonZeroIndex >= 0) {
        setActiveIndex(firstNonZeroIndex);
      }

      setLoading(false);
      // setGraphaging(response.data.aging_graph)
      setGraphaging(response.data.invoice_bucket);
      setGraphinterest_rate_data(response.data.interest_rate_data);
      setUnappliedpayments(response.data.unappliedPayments);
      setActiveContract(response.data.activecontract);
      setPendingcontract(response.data.contracts);
      setUnappliedreceipt(response.data.receipts);
      setInvoicess(response.data.invoices);
      setLoading(false);
      setValue({
        AmountFinanced: response.data.amountfinaced.financed_amount,
        PendingContracts: response.data.pendingcontracts,
        AmountDue: response.data.Amountdue.balance_amount,
        PaymentsApplied:
          response.data.PaymentsApplied.applied_amount !== null
            ? response.data.PaymentsApplied.applied_amount
            : "0.0",
        unappliedPayments:
          response.data.unappliedPayments !== null
            ? response.data.unappliedPayments.total_amount
            : "0.0",
        netInvestment: response.data.netinvestment,
        // averageLeaseTerm: response.data.contract_remaining_term,
        endofLeaseAssetValue: response.data.residual_value,
        averageOriginalTerm: response.data.avg_original_term,
        averageRemainingTerm: response.data.avg_remaining_term,
      });
    });
  };

  const navigate = useNavigate();

  const hadnlependingcontract = () => {
    navigate("/contract", { state: "Entered" });
  };
  const hadnlecontract = () => {
    navigate("/contract", { state: "Active" });
  };
  const handleInvoice = () => {
    navigate("/billing", { state: "Pending" });
  };
  const handleReceipt = () => {
    navigate("/receipts", { state: "unapplied" });
  };

  const today = new Date();
  let lastSixMonths = [];

  for (var i = 6; i > 0; i -= 1) {
    const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
    lastSixMonths.push(moment(date).format("MMMM YYYY"));
  }

  let isAddAPICalled = false;
  const handleInputChange = async (
    name,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");

    const widget = widgetData.filter(
      (val) => val.widget === 1 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }

    setOrderNo(newOrderNo);

    if (checked) {
      const body = {
        widget: 1,
        name: name,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
          isAddAPICalled = true;
        }
      });
    } else {
      if (!isAddAPICalled) {
        axios
          .delete(
            API +
              `widgets/widgetoptiondelete/?user_id=${user_id}&name=${name}&dashboard_type=${dashboardType}`
          )
          .then((response) => {
            if (response.data.success === "True") {
              const res = handleWidget();
              const data = res.filter((val) => val.widget === 1);
              const val = data.map((val) => val.name);
              setCheckbox(val);
            }
          });
      }
    }
  };

  const handleInputChangeCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 2 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 2,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
      setIsContractsChecked(!isContractsChecked);
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
      setIsContractsChecked(!isContractsChecked);
    }
  };

  const handleInputRecepitCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 2 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 2,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };

  const handleInputDelinquencyCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 2 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 2,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };
  const handleInputPieCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 2 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 2,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };

  const handleInputInterestrateCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 2 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 2,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };

  const handlePendingCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 3 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 3,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };
  const handleInvoiceCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 3 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 3,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };

  const handleContractCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 3 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 3,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };

  const handlePaymentCheck = async (
    value,
    checked,
    dashboardType = selectedDashboard
  ) => {
    const user_id = localStorage.getItem("userid");
    const widget = widgetData.filter(
      (val) => val.widget === 3 && val.dashboard_type === dashboardType
    );
    let newOrderNo = orderNo;

    if (widget.length === 0) {
      newOrderNo = orderNo + 1;
    } else {
      const maxOrderNo = Math.max(...widget.map((item) => item.order_no));
      newOrderNo = maxOrderNo + 1;
    }
    setOrderNo(newOrderNo);
    if (checked) {
      const body = {
        widget: 3,
        name: value,
        order_no: newOrderNo,
        user_id: user_id,
        dashboard_type: dashboardType,
      };
      axios.post(API + "widgets/widgetoption/", body).then((response) => {
        if (response.data.success === "True") {
          const res = handleWidget();
          const data = res.filter((val) => val.widget === 1);
          const val = data.map((val) => val.name);
          setCheckbox(val);
        }
      });
      await handleWidget();
    } else {
      axios
        .delete(
          API +
            `widgets/widgetoptiondelete/?user_id=${user_id}&name=${value}&dashboard_type=${dashboardType}`
        )
        .then((response) => {
          if (response.data.success === "True") {
            const res = handleWidget();
            const data = res.filter((val) => val.widget === 1);
            const val = data.map((val) => val.name);
            setCheckbox(val);
          }
        });
      await handleWidget();
    }
  };

  const handleDragStart = (e, key) => {
    e.dataTransfer.setData("text/plain", key);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = async (e, targetKey) => {
    e.preventDefault();
    const draggedName = e.dataTransfer.getData("text/plain");
    if (draggedName === targetKey) {
      return;
    }
    const updatedCheckbox = [...checkbox];
    const draggedIndex = updatedCheckbox.findIndex(
      (item) => item === draggedName
    );
    const targetIndex = updatedCheckbox.findIndex((item) => item === targetKey);

    if (draggedIndex !== -1 && targetIndex !== -1) {
      [updatedCheckbox[draggedIndex], updatedCheckbox[targetIndex]] = [
        updatedCheckbox[targetIndex],
        updatedCheckbox[draggedIndex],
      ];

      setCheckbox(updatedCheckbox);

      const draggedId = widgetData.find(
        (val) =>
          val.name === draggedName && val.dashboard_type === selectedDashboard
      )?.id;
      const targetId = widgetData.find(
        (val) =>
          val.name === targetKey && val.dashboard_type === selectedDashboard
      )?.id;

      const updateWidgetOptionAPI = async (id, orderNo, name) => {
        const user_id = localStorage.getItem("userid");
        try {
          const response = await fetch(
            API + `widgets/widgetoptionupdate/${id}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                name: name,
                order_no: orderNo,
                user_id: user_id,
                widget: 1,
                dashboard_type: selectedDashboard,
              }),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to update widget option");
          }
        } catch (error) {
          console.error("Error updating widget option:", error.message);
        }
      };
      if (draggedId !== undefined) {
        updateWidgetOptionAPI(draggedId, targetIndex + 1, draggedName);
      }

      if (targetId !== undefined) {
        updateWidgetOptionAPI(targetId, draggedIndex + 1, targetKey);
      }
    }

    if (targetKey === "Amount Financed") {
      setValue([...value, items.financed_amount]);
    }
  };

  const handleDragStartChart = (e, key) => {
    e.dataTransfer.setData("text/plain", key);
  };

  const handleDragOverChart = (e) => {
    e.preventDefault();
  };

  const handleDropChart = (e, targetKey) => {
    e.preventDefault();
    const draggedName = e.dataTransfer.getData("text/plain");
    if (draggedName === targetKey) {
      return;
    }
    const updatedCheckbox = [...charts];
    const draggedIndex = updatedCheckbox.findIndex(
      (item) => item.key === draggedName
    );
    const targetIndex = updatedCheckbox.findIndex(
      (item) => item.key === targetKey
    );

    if (draggedIndex !== -1 && targetIndex !== -1) {
      [updatedCheckbox[draggedIndex], updatedCheckbox[targetIndex]] = [
        updatedCheckbox[targetIndex],
        updatedCheckbox[draggedIndex],
      ];

      setCharts(updatedCheckbox);

      const draggedId = widgetData.find(
        (val) =>
          val.widget === 2 &&
          val.name === draggedName &&
          val.dashboard_type === selectedDashboard
      )?.id;
      const targetId = widgetData.find(
        (val) =>
          val.widget === 2 &&
          val.name === targetKey &&
          val.dashboard_type === selectedDashboard
      )?.id;

      const updateWidgetOptionAPI = async (id, orderNo, name) => {
        const user_id = localStorage.getItem("userid");
        try {
          const response = await fetch(
            API + `widgets/widgetoptionupdate/${id}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                name: name,
                order_no: orderNo,
                user_id: user_id,
                widget: 2,
                dashboard_type: selectedDashboard,
              }),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to update widget option");
          }
        } catch (error) {
          console.error("Error updating widget option:", error.message);
        }
      };
      if (draggedId !== undefined) {
        updateWidgetOptionAPI(draggedId, targetIndex + 1, draggedName);
      }

      if (targetId !== undefined) {
        updateWidgetOptionAPI(targetId, draggedIndex + 1, targetKey);
      }
    }
  };

  const handleDragStartTable = (e, key) => {
    e.dataTransfer.setData("text/plain", key);
  };

  const handleDragOverTable = (e) => {
    e.preventDefault();
  };

  const handleDroptable = (e, targetKey) => {
    e.preventDefault();
    const draggedName = e.dataTransfer.getData("text/plain");
    if (draggedName === targetKey) {
      return;
    }
    const updatedCheckbox = [...tableData];
    const draggedIndex = updatedCheckbox.findIndex(
      (item) => item.key === draggedName
    );
    const targetIndex = updatedCheckbox.findIndex(
      (item) => item.key === targetKey
    );

    if (draggedIndex !== -1 && targetIndex !== -1) {
      [updatedCheckbox[draggedIndex], updatedCheckbox[targetIndex]] = [
        updatedCheckbox[targetIndex],
        updatedCheckbox[draggedIndex],
      ];

      setTableData(updatedCheckbox);

      const draggedId = widgetData.find(
        (val) =>
          val.widget === 3 &&
          val.name === draggedName &&
          val.dashboard_type === selectedDashboard
      )?.id;
      const targetId = widgetData.find(
        (val) =>
          val.widget === 3 &&
          val.name === targetKey &&
          val.dashboard_type === selectedDashboard
      )?.id;

      const updateWidgetOptionAPI = async (id, orderNo, name) => {
        const user_id = localStorage.getItem("userid");
        try {
          const response = await fetch(
            API + `widgets/widgetoptionupdate/${id}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                name: name,
                order_no: orderNo,
                user_id: user_id,
                widget: 3,
                dashboard_type: selectedDashboard,
              }),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to update widget option");
          }
        } catch (error) {
          console.error("Error updating widget option:", error.message);
        }
      };
      if (draggedId !== undefined) {
        updateWidgetOptionAPI(draggedId, targetIndex + 1, draggedName);
      }

      if (targetId !== undefined) {
        updateWidgetOptionAPI(targetId, draggedIndex + 1, targetKey);
      }
    }
  };

  const handleExpanded = (value) => {
    if (expanded === value) {
      setExpanded(null);
      localStorage.removeItem("expandedItem");
    } else {
      setExpanded(value);
      localStorage.setItem("expandedItem", value);
    }
  };

  useEffect(() => {
    handelDefault();
  }, []);

  useEffect(() => {
    const storedItem = localStorage.getItem("expandedItem");
    if (
      storedItem &&
      tableData &&
      tableData.some((item) => item.key === storedItem)
    ) {
      setExpanded(storedItem);
    }
  }, [tableData]);

  const handleWidget = async () => {
    const user_id = localStorage.getItem("userid");
    const response = await axios.get(
      API +
        `widgets/widgetoption/?user_id=${user_id}&dashboard_type=${selectedDashboard}`
    );
    setWidgetData(response.data);
    const data =
      response.data &&
      response.data
        .filter(
          (val) => val.widget === 1 && val.dashboard_type === selectedDashboard
        )
        .sort((a, b) => a.order_no - b.order_no)
        .map((val) => val.name);

    setCheckbox(data);

    const contrasbymonth =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 2 &&
          val.name === "Contracts by Month" &&
          val.dashboard_type === selectedDashboard
      );
    const receiptbymonth =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 2 &&
          val.name === "Receipts by Month" &&
          val.dashboard_type === selectedDashboard
      );
    const DelinquencyAging =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 2 &&
          val.name === "Delinquency Aging" &&
          val.dashboard_type === selectedDashboard
      );
    const interest_rate_data =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 2 &&
          val.name === "Lease Revenue and Profitability" &&
          val.dashboard_type === selectedDashboard
      );
    const pie_chart =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 2 &&
          val.name === "Asset Concentration" &&
          val.dashboard_type === selectedDashboard
      );
    const pendingcontracts =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 3 &&
          val.name === "Pending Contract" &&
          val.dashboard_type === selectedDashboard
      );
    const invoicesDue =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 3 &&
          val.name === "Invoices Due" &&
          val.dashboard_type === selectedDashboard
      );
    const Contracts =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 3 &&
          val.name === "Contracts" &&
          val.dashboard_type === selectedDashboard
      );
    const UnappliedPayment =
      response.data &&
      response.data.map(
        (val) =>
          val.widget === 3 &&
          val.name === "Unapplied Payment" &&
          val.dashboard_type === selectedDashboard
      );
    if (contrasbymonth.includes(true)) {
      setIsContractsChecked(true);
    } else {
      setIsContractsChecked(false);
    }
    if (receiptbymonth.includes(true)) {
      setIsReceiptsChecked(true);
    } else {
      setIsReceiptsChecked(false);
    }
    if (DelinquencyAging.includes(true)) {
      setIsDelinquencyAging(true);
    } else {
      setIsDelinquencyAging(false);
    }
    if (pie_chart.includes(true)) {
      setPiechart(true);
    } else {
      setPiechart(false);
    }
    if (interest_rate_data.includes(true)) {
      setIsLeaseRevenueandProfitability(true);
    } else {
      setIsLeaseRevenueandProfitability(false);
    }
    //table data
    if (pendingcontracts.includes(true)) {
      setIsPendingcontracts(true);
    } else {
      setIsPendingcontracts(false);
    }
    if (invoicesDue.includes(true)) {
      setIsInvoicesDue(true);
    } else {
      setIsInvoicesDue(false);
    }
    if (Contracts.includes(true)) {
      setIsContract(true);
    } else {
      setIsContract(false);
    }
    if (UnappliedPayment.includes(true)) {
      setIsUnappliedPayments(true);
    } else {
      setIsUnappliedPayments(false);
    }
    return response.data;
  };

  useEffect(() => {
    const sortedTableData =
      widgetData &&
      widgetData
        .filter(
          (val) => val.widget === 3 && val.dashboard_type === selectedDashboard
        )
        .sort((a, b) => a.order_no - b.order_no);

    const updatedTableData =
      sortedTableData &&
      sortedTableData.map((val) => {
        if (val.name === "Pending Contract") {
          return {
            key: "Pending Contract",
            component: () => (
              <PendingContracts
                contract={pendingcon}
                customerPermission={customerPermission}
              />
            ),
          };
        } else if (val.name === "Invoices Due") {
          return {
            key: "Invoices Due",
            component: () => <InvoicesDue invoice={invoicess} />,
          };
        } else if (val.name === "Contracts") {
          return {
            key: "Contracts",
            component: () => (
              <Contractsdashboard activecontract={activecontract} />
            ),
          };
        } else if (val.name === "Unapplied Payment") {
          return {
            key: "Unapplied Payment",
            component: () => (
              <UnappliedPayments unappliedpayments={unappliedreceipt} />
            ),
          };
        } else {
          return null;
        }
      });

    setTableData(updatedTableData);
  }, [
    pendingcon,
    invoicess,
    activecontract,
    unappliedreceipt,
    customerPermission,
    widgetData,
    selectedDashboard,
  ]);

  useEffect(() => {
    handleWidget();
  }, [selectedDashboard]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 480;
  const isSmallTablet = windowWidth >= 480 && windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;
  const isLargeTablet = windowWidth >= 1024 && windowWidth < 1280;

  const getChartDimensions = () => {
    const containerWidth = windowWidth;

    let chartHeight, outerRadius;

    if (isMobile) {
      chartHeight = 180;
      outerRadius = Math.min(containerWidth * 0.2, 60);
    } else if (isSmallTablet) {
      chartHeight = 200;
      outerRadius = Math.min(containerWidth * 0.18, 70);
    } else if (isTablet) {
      chartHeight = 210;
      outerRadius = Math.min(containerWidth * 0.15, 80);
    } else if (isLargeTablet) {
      chartHeight = 220;
      outerRadius = Math.min(containerWidth * 0.12, 90);
    } else {
      chartHeight = 240;
      outerRadius = Math.min(containerWidth * 0.1, 100);
    }

    return { chartHeight, outerRadius };
  };
  const { chartHeight, outerRadius } = getChartDimensions();
  const getLegendConfig = () => {
    let layout, align, verticalAlign, wrapperStyle;

    if (isMobile) {
      layout = "horizontal";
      align = "center";
      verticalAlign = "bottom";
      wrapperStyle = {
        paddingTop: 10,
        fontSize: "10px",
        width: "100%",
      };
    } else if (isSmallTablet || isTablet) {
      layout = "horizontal";
      align = "center";
      verticalAlign = "bottom";
      wrapperStyle = {
        paddingTop: 10,
        fontSize: "11px",
        width: "100%",
      };
    } else {
      layout = "vertical";
      align = "right";
      verticalAlign = "middle";
      wrapperStyle = {
        fontSize: "12px",
        width: "40%",
        maxWidth: "200px",
      };
    }

    return { layout, align, verticalAlign, wrapperStyle };
  };

  const legendConfig = getLegendConfig();
  useEffect(() => {
    const dataChart =
      widgetData &&
      widgetData
        .filter(
          (val) => val.widget === 2 && val.dashboard_type === selectedDashboard
        )
        .sort((a, b) => a.order_no - b.order_no)
        .map((val) => val.name);
    const COLORS = [
      "#0088FE",
      "#00C49F",
      "#FFBB28",
      "#FF8042",
      "#8884D8",
      "#82CA9D",
      "#FFC658",
      "#8DD1E1",
      "#A4DE6C",
      "#D0ED57",
      "#F7A35C",
      "#E4D354",
      "#7CB5EC",
      "#90ED7D",
      "#F45B5B",
      "#91E8E1",
    ];

    const pdata = graphcontract.map((key) => ({
      name: moment()
        .month(key.month - 1)
        .format("MMMM"),
      Contracts: key.count,
      Invoices: 10,
    }));

    const pdata1 = graphreceipt.map((key) => ({
      name: moment()
        .month(key.month - 1)
        .format("MMMM"),
      Receipts: key.count,
      Amount: key.amount,
    }));

    const pdata2 =
      graphaging &&
      graphaging.map((key) => ({
        name: key.range,
        Amount: key.amount,
      }));

    const pdata3 =
      graphinterest_rate_data &&
      graphinterest_rate_data.map((key) => ({
        name: key.range,
        "IRR/Interest p.a.": key.iir_sum,
      }));

    const totalAllocatedPercentage = datacategory.reduce(
      (sum, item) => sum + item.percentage,
      0
    );
    const unusedPercentage = +(100 - totalAllocatedPercentage).toFixed(2);
    const safeData = datacategory || [];

    const totalValue = datacategory.reduce((sum, item) => sum + item.value, 0);

    // Filter out Empty items for the legend
    const legendItems = datacategory.filter((item) => !item.isEmpty);
    const categoryChartData = (safeData || []).map((category, index) => {
      return {
        name: category.name,
        displayName: `${category.name} (${category.percentage}%)`,
        value: category.percentage,
        percentage: category.percentage,
        originalData: category,
        color: COLORS[index % COLORS.length],
        isZero: category.percentage === 0,
      };
    });

    if (unusedPercentage > 0) {
      categoryChartData.push({
        name: "Empty",
        displayName: `Empty (${unusedPercentage}%)`,
        value: unusedPercentage,
        percentage: unusedPercentage,
        originalData: {
          category: "Empty",
          name: "Empty",
          total_item_count: 0,
          total_value: 0,
          percentage: unusedPercentage,
        },
        color: "#E0E0E0",
        isUnused: true,
      });
    }
    const handlePieEnter = (data, index) => {
      setActiveIndex(index);
    };

    const handleViewAll = () => {
      // Navigate to Reports screen and pass state
      navigate("/reports", {
        state: { report: "invoices", viewInvoice: "invoiceaging" },
      });
    };

    const CustomTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
        const item = payload[0].payload;
        const color = item.color;

        if (item.isUnused) {
          return (
            <div className="bg-white p-3 border border-gray-200 rounded shadow-md">
              <p className="font-bold text-base" style={{ color }}>
                Empty
              </p>
              <div className="mt-1">
                <div className="flex justify-between text-sm">
                  <span style={{ color }}>Percentage:</span>
                  <span className="ml-4 font-medium">{item.percentage}%</span>
                </div>
              </div>
            </div>
          );
        }
        const category = item.originalData;

        const formattedValue = Helper.Amount(category.total_value);

        return (
          <div className="bg-white p-3 border border-gray-200 rounded shadow-md">
            <p className="font-bold text-base" style={{ color }}>
              {item.name}
            </p>
            <div className="mt-1">
              {!item.isZero ? (
                <>
                  <div className="flex justify-between text-sm">
                    <span style={{ color }}>Percentage:</span>
                    <span className="ml-4 font-medium">
                      {category.percentage}%
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span style={{ color }}>Total Value:</span>
                    <span className="ml-4 font-medium">{formattedValue}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-between text-sm">
                    <span style={{ color }}>Status:</span>
                    <span className="ml-4 font-medium">No Items</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span style={{ color }}>Total Value:</span>
                    <span className="ml-4 font-medium">0</span>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      }
      return null;
    };

    const renderCustomizedLabel = (props) => {
      const { cx, cy, midAngle, innerRadius, outerRadius, index } = props;
      const RADIAN = Math.PI / 180;
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      const item = categoryChartData[index];

      if (item && item.isUnused) {
        return (
          <text
            x={x}
            y={y}
            fill="#FFFFFF"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize={12}
            fontWeight="bold"
          ></text>
        );
      }

      if (item && item.percentage >= 5 && !item.isZero) {
        return null;
      }
      return null;
    };
    const availableCharts = {
      "Receipts by Month": {
        key: "Receipts by Month",
        component: () => (
          <ResponsiveContainer width="100%" aspect={3}>
            <AreaChart
              width={500}
              height={300}
              data={pdata1}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#008DC1" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#008DC1" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip formatter={(value, name) => {
                if (name === "Amount") {
                  return Helper.Amount(value);
                }
                return value; // keep Receipts as number
              }}  />
              <Legend />
              <Area
                type="monotone"
                dataKey="Receipts"
                stroke="#245C7F"
                fillOpacity={1}
                fill="url(#colorUv)"
              />
              <Area
                type="monotone"
                dataKey="Amount"
                stroke="#82ca9d"
                fillOpacity={1}
                fill="url(#colorPv)"
              />
            </AreaChart>
          </ResponsiveContainer>
        ),
      },
      "Contracts by Month": {
        key: "Contracts by Month",
        component: () => (
          <ResponsiveContainer width="100%" aspect={3}>
            <BarChart width={730} height={250} data={pdata}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Contracts" fill="#245C7F" />
            </BarChart>
          </ResponsiveContainer>
        ),
      },
      "Delinquency Aging": {
        key: "Delinquency Aging",
        component: () => (
          <>
          <h5
          className="mb-3 tc col-form-label"
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            color: "#245C7F",
          }}
          onClick={handleViewAll}
        >
          Delinquency Aging
        </h5>
            {/* <div style={{ position: "absolute", top: 10, right: 10 }}>
              <button
                className="btn btn-primary btn-sm"
                style={{
                  padding: "5px 10px",
                  backgroundColor: "#82ca9d",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={handleViewAll} // Replace with your logic for "View All"
              >
                View All
              </button>
            </div> */}
            <ResponsiveContainer width="100%" aspect={3}>
              <BarChart width={730} height={250} data={pdata2}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis
                  tickFormatter={formatYAxis} // Format large numbers
                  tick={{ fontSize: 12 }}
                  label={{
                    value: "Amount",
                    angle: -90,
                    position: "insideLeft",
                    offset: -10,
                  }}
                />
                <Tooltip formatter={(value) => Helper.Amount(value)} />
                <Legend />
                <Bar dataKey="Amount" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </>
          // <ResponsiveContainer width="100%" aspect={3}>
          //   <AreaChart
          //     width={500}
          //     height={300}
          //     data={pdata2}
          //     margin={{
          //       top: 5,
          //       right: 30,
          //       left: 20,
          //       bottom: 5,
          //     }}
          //   >
          //     <defs>
          //       <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
          //         <stop offset="5%" stopColor="#008DC1" stopOpacity={0.8} />
          //         <stop offset="95%" stopColor="#008DC1" stopOpacity={0} />
          //       </linearGradient>
          //       <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
          //         <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
          //         <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
          //       </linearGradient>
          //     </defs>
          //     <CartesianGrid strokeDasharray="3 3" />
          //     <XAxis dataKey="name" />
          //     <YAxis />
          //     <Tooltip />
          //     <Legend />
          //     <Area type="monotone" dataKey="Delinquency Aging" stroke="#245C7F" fillOpacity={1} fill="url(#colorUv)" />
          //     <Area type="monotone" dataKey="Amount" stroke="#008DC1" fillOpacity={1} fill="url(#colorUv)" />
          //   </AreaChart>
          // </ResponsiveContainer>
        ),
      },
      "Lease Revenue and Profitability": {
        key: "Lease Revenue and Profitability",
        component: () => (
          <ResponsiveContainer width="100%" aspect={3}>
            <BarChart width={730} height={250} data={pdata3}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip formatter={(value) => Helper.Amount(value)} />
              <Legend />
              <Bar dataKey="IRR/Interest p.a." fill="#008DC1" />
            </BarChart>
          </ResponsiveContainer>
        ),
      },
      "Asset Concentration": {
        key: "Asset Concentration",
        component: () => (
          <>
           <h5
          className="mb-3 tc col-form-label"
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            color: "#245C7F",
          }}
          onClick={handleAssetConcentration}
        >
          Asset Concentration
        </h5>
            {/* <div style={{ position: "absolute", top: 10, right: 10 }}>
              <button
                className="btn btn-primary btn-sm"
                style={{
                  padding: "5px 10px",
                  backgroundColor: "#82ca9d",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={handleAssetConcentration} // Replace with your logic for "View All"
              >
                View All
              </button>
            </div> */}
            <div style={{ minHeight: 240 }}>
              <ResponsiveContainer
                width="100%"
                height={window.innerWidth < 768 ? 280 : 240}
                debounce={50}
              >
                <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                  <Pie
                    data={categoryChartData}
                    dataKey="value"
                    nameKey="displayName"
                    cx="50%"
                    cy="50%"
                    outerRadius={window.innerWidth < 768 ? 60 : 80}
                    labelLine={false}
                    label={renderCustomizedLabel}
                    onMouseEnter={handlePieEnter}
                    isAnimationActive={true}
                  >
                    {categoryChartData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={entry.color}
                        stroke="#FFFFFF"
                        strokeWidth={activeIndex === index ? 2 : 1}
                      />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    layout={legendConfig.layout}
                    align={legendConfig.align}
                    verticalAlign={legendConfig.verticalAlign}
                    wrapperStyle={legendConfig.wrapperStyle}
                    formatter={(value, entry) => (
                      <span style={{ color: entry.color }}>
                        {entry.category} ({entry.percentage}%)
                      </span>
                    )}
                    payload={datacategory.map((item, index) => ({
                      value: item.category,
                      type: "square",
                      color: COLORS[index % COLORS.length],
                      category: item.category,
                      percentage: item.percentage,
                    }))}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </>
        ),
      },
    };
    const chartsConfig =
      dataChart && dataChart.map((chartName) => availableCharts[chartName]);
    setCharts(chartsConfig);
  }, [
    graphcontract,
    graphreceipt,
    widgetData,
    graphaging,
    graphinterest_rate_data,
    isMobile,
    outerRadius,
    selectedDashboard,
  ]);

  const handleView = () => {
    navigate("/reports", {
      state: { report: "recipts", viewReceipts: "unappliedreceipts" },
    });
  };
  
  const handlePendingView = () => {
    navigate("/reports", {
      state: { report: "contracts", viewContracts: "ContractsByStatus" },
    });
  };
  const handleNetinvestmentView = () => {
    navigate("/reports", {
      state: { report: "contracts", viewContracts: "ActiveContract" },
    });
  };
  const handleAverageTermOriginal = () => {
    navigate("/reports", {
      state: { report: "contracts", viewContracts: "Contractsoriginalterm" },
    });
  };
  const handleAverageTermRemaining = () => {
    navigate("/reports", {
      state: { report: "contracts", viewContracts: "Contractsremainingterm" },
    });
  };
  const handleAssetConcentration = () => {
    navigate("/reports", {
      state: { report: "assets", viewInventory: "assetreport" },
    });
  };

  // Custom tick formatter for Y-axis to handle large numbers
  const formatYAxis = (tick) => {
    if (tick >= 1000000) {
      return `${tick / 1000000}M`;
    } else if (tick >= 1000) {
      return `${tick / 1000}K`;
    }
    return tick;
  };

  const handleDashboardChange = (event) => {
    setSelectedDashboard(event.target.value);
  };

  const modalInstanceRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const modalElement = document.getElementById("myModal");

    if (modalElement) {
      console.log("Initializing Bootstrap modal instance");
      modalInstanceRef.current = new window.bootstrap.Modal(modalElement, {
        backdrop: true,
        keyboard: true,
      });

      // Add event listeners to sync with React state
      modalElement.addEventListener("shown.bs.modal", () => {
        console.log("Modal shown event fired");
        setIsModalOpen(true);
      });
      modalElement.addEventListener("hidden.bs.modal", () => {
        console.log("Modal hidden event fired");
        setIsModalOpen(false);
      });

      // Cleanup
      return () => {
        console.log("Cleaning up Bootstrap modal instance");
        if (modalInstanceRef.current) {
          modalInstanceRef.current.dispose();
        }
        modalElement.removeEventListener("shown.bs.modal", () => {});
        modalElement.removeEventListener("hidden.bs.modal", () => {});
      };
    } else {
      console.error("Modal element (#myModal) not found in DOM");
    }
  }, []);

  // Open modal function
  const openModal = () => {
    if (modalInstanceRef.current) {
      console.log("Opening modal");
      modalInstanceRef.current.show();
      setIsModalOpen(true); // Ensure React state is updated
    } else {
      console.error("Modal instance not initialized");
    }
  };

  // Close modal function
  const closeModal = () => {
    console.log("closeModal called");
    if (modalInstanceRef.current) {
      console.log("Modal instance exists, attempting to hide");
      try {
        modalInstanceRef.current.hide();
        console.log("hide() method called successfully");
      } catch (error) {
        console.error("Error calling hide():", error);
      }
    } else {
      console.error("Modal instance not initialized");
    }
    setIsModalOpen(false); // Ensure React state is updated
    console.log("closeModal finished");
  };

  return (
    <>
      {loading === false ? (
        <div>
          {
            customerPermission !== "Customer" && (
              <div className=" container-fluid py-4">
                <div className="row row d-flex align-items-center justify-content-between">
                  <div className="col-auto">
                    <select
                      value={selectedDashboard}
                      onChange={handleDashboardChange}
                      className="form-select"
                      style={{ width: "200px", padding: "8px" }}
                    >
                      <option value="Command Center">Command Center</option>
                      <option value="Operations">Operations</option>
                      <option value="Finance">Finance</option>
                    </select>
                  </div>
                  <div className="col-auto">
                    <div data-bs-toggle="modal" data-bs-target="#myModal">
                      <ReactTippy position="right" title="Widget Library">
                        <WidgetsIcon
                          style={{
                            color: "#245C7F",
                            width: "100%",
                            height: "30px",
                            cursor: "pointer",
                          }}
                        />
                      </ReactTippy>
                    </div>
                  </div>
                </div>
              </div>
            )
            //               <div className="container-fluid py-2 py-sm-4">
            //   <div className="row d-flex align-items-center justify-content-between">
            //     <div className="col-6">
            //       <select
            //         value={selectedDashboard}
            //         onChange={handleDashboardChange}
            //         className="form-select"
            //         style={{ width: '100%', maxWidth: '200px', padding: '6px' }}
            //       >
            //         <option value="Command Center">Command Center</option>
            //         <option value="Operations">Operations</option>
            //         <option value="Finance">Finance</option>
            //       </select>
            //     </div>
            //     <div className="col-auto" >

            //           <div
            //                     onClick={(e) => {
            //                       e.stopPropagation();
            //                       openModal();
            //                     }}
            //                   >
            //                      <ReactTippy position='right' title='Widget' interactive={true}>
            //                      <WidgetsIcon style={{ color: '#245C7F', width: '100%', height: '30px', cursor: 'pointer' }} />
            //                      </ReactTippy>
            //       </div>
            //     </div>
            //   </div>
            // </div>
          }
           <div className="modal" id="myModal">
                  <div
                    className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                    style={{ height: "115px" }}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        {/* <h4 className="modal-title">Widget Options</h4> */}
                        <h4 className="modal-title">Widget Library</h4>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div
                            className="section"
                            style={{ marginBottom: "10px" }}
                          >
                            <h5 className="section-title">Tiles</h5>
                            <div
                              className="checkbox-container"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="amountFinanced"
                                  value="Amount Financed"
                                  checked={checkbox.includes("Amount Financed")}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="amountFinanced"
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Amount Financed
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="pendingContracts"
                                  value="Pending Contracts"
                                  checked={checkbox.includes(
                                    "Pending Contracts"
                                  )}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="pendingContracts"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Pending Contracts
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="amountDue"
                                  value="Amount Due"
                                  checked={checkbox.includes("Amount Due")}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="amountDue"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Amount Due
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="paymentsApplied"
                                  value="Payments Applied"
                                  checked={checkbox.includes(
                                    "Payments Applied"
                                  )}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="paymentsApplied"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Payments Applied
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="unappliedPayments"
                                  value="Unapplied Payments"
                                  checked={checkbox.includes(
                                    "Unapplied Payments"
                                  )}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="unappliedPayments"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Unapplied Payments
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="netinvestment"
                                  value="Net Investment"
                                  checked={checkbox.includes("Net Investment")}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="netInvestment"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Net Investment
                                </label>
                              </div>
                              {/* <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="averageLeaseTerm"
                                  value="Average Lease Term"
                                  checked={checkbox.includes(
                                    "Average Lease Term"
                                  )}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="averageLeaseTerm"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Average Lease Term
                                </label>
                              </div> */}
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="endofleaseassetvalue"
                                  value="End of Lease Asset Value"
                                  checked={checkbox.includes(
                                    "End of Lease Asset Value"
                                  )}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="endofLeaseAssetValue"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  End of Lease Asset Value
                                </label>
                              </div>
                               <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="averageOriginalTerm"
                                  value="Average Term Original"
                                  checked={checkbox.includes(
                                    "Average Term Original" 
                                  )}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="averageOriginalTerm"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Average Term Original (Months)
                                </label>
                              </div>
                               <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="averageRemainingTerm"
                                  value="Average Term Remaining"
                                  checked={checkbox.includes(
                                    "Average Term Remaining" 
                                  )}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="averageRemainingTerm"
                                  style={{ whiteSpace: "nowrap" }}
                                  className="labledata"
                                >
                                  Average Term Remaining (Months)
                                </label>
                              </div>
                            </div>
                          </div>
                          <div
                            className="section"
                            style={{ marginBottom: "10px" }}
                          >
                            <h5 className="section-title">Charts</h5>
                            <div
                              className="checkbox-container"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Contracts by Month"
                                  checked={isContractsChecked}
                                  onChange={(e) =>
                                    handleInputChangeCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Contracts by Month
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Receipts by Month"
                                  checked={isReceiptsChecked}
                                  onChange={(e) =>
                                    handleInputRecepitCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Receipts by Month
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Delinquency Aging"
                                  checked={isDelinquencyAging}
                                  onChange={(e) =>
                                    handleInputDelinquencyCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Delinquency Aging
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Lease Revenue and Profitability"
                                  checked={isleaseRevenueandProfitability}
                                  onChange={(e) =>
                                    handleInputInterestrateCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Lease Revenue and Profitability
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Asset Concentration"
                                  checked={piechart}
                                  onChange={(e) =>
                                    handleInputPieCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Asset Concentration
                                </label>
                              </div>
                            </div>
                          </div>
                          <div
                            className="section"
                            style={{ marginBottom: "10px" }}
                          >
                            <h5 className="section-title">Tables</h5>
                            <div
                              className="checkbox-container"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Pending Contract"
                                  checked={isPendingcontracts}
                                  onChange={(e) =>
                                    handlePendingCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Pending Contracts
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Invoices Due"
                                  checked={isinvoicesDue}
                                  onChange={(e) =>
                                    handleInvoiceCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Invoices Due
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Contracts"
                                  checked={iscontract}
                                  onChange={(e) =>
                                    handleContractCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Contracts
                                </label>
                              </div>
                              <div
                                class="checkbox-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value="Unapplied Payment"
                                  checked={isUnappliedPayments}
                                  onChange={(e) =>
                                    handlePaymentCheck(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  className="labledata"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Unapplied Payments
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

          {selectedDashboard === "Command Center" && (
            <>
              <div className="container-fluid py-2">
                {customerPermission !== "Customer" && (
                  <div className="header pb-0 mb-3 d-flex justify-content-between align-items-center">
                    {/* <h5 className="tc">{t('Overview')}</h5> */}
                    {/* <h5>{t('Dashboard')}</h5> */}
                    {/* <h5>{t('Command Center')}</h5> */}
                    {/* <div data-bs-toggle="modal" data-bs-target="#myModal">
                    <ReactTippy position='right' title='Widget'>
                      <WidgetsIcon style={{ color: '#245C7F', width: '100%', height: '30px', cursor: 'pointer' }} />
                    </ReactTippy>
                  </div> */}
                    {/* <button type="button" className="button btn btn-primary" data-bs-toggle="modal" data-bs-target="#myModal">
                    Widget Options
                  </button> */}
                  </div>
                )}
                
               
                <div
                  className="row"
                  id="show_page"
                  style={{ marginBottom: "-2%" }}
                >
                  {checkbox.map((val) => (
                    <div
                      key={val.name}
                      className={`col-xl-${Math.floor(
                        12 / (checkbox.length <= 6 ? checkbox.length : 6)
                      )} col-md-4 col-sm-6 mb-4`}
                      draggable="true"
                      onDragStart={(e) => handleDragStart(e, val)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDrop={(e) => handleDrop(e, val)}
                    >
                      <div className="card ">
                        <div className="card-body">
                          {val === "Pending Contracts" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontSize: '16px',
                                fontWeight:700,
                              }}
                              onClick={handlePendingView}
                            >
                              Pending Contracts
                            </h5>
                          ) : val === "Unapplied Payments" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '16px'
                              }}
                              onClick={handleView}
                            >
                              Unapplied Payments
                            </h5>
                          ) 
                          : 
                          val === "Net Investment" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '16px'
                              }}
                              onClick={handleNetinvestmentView}
                            >
                              Net Investment
                            </h5>
                          ) 
                          :
                          val === "Average Term Original" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '15px'
                              }}
                              onClick={handleAverageTermOriginal}
                            >
                              Average Term Original (Months)
                            </h5>
                          ) 
                          :
                          val === "Average Term Remaining" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '15px'
                              }}
                              onClick={handleAverageTermRemaining}
                            >
                              Average Term Remaining (Months)
                            </h5>
                          ) 
                          :

                          (
                            <label
                              className="overview"
                              style={{ fontSize: "16px" }}
                            >
                              {val}
                            </label>
                          )}
                          {/* <label
                            className="overview"
                            style={{ fontSize: "16px" }}
                          >
                            {val}
                          </label> */}
                          <h5 style={{ color: "#1DBB55" }}>
                            {(val === "Amount Financed" ||
                              val === "Payments Applied" ||
                              val === "Unapplied Payments")
                              // "$"
                              }
                            {val === "Amount Financed"
                              ? Helper.Amount(value.AmountFinanced) ??
                                Helper.Amount(0)
                              : val === "Pending Contracts"
                              ? value.PendingContracts ?? 0
                              : val === "Amount Due"
                              ? Helper.Amount(value.AmountDue) ??
                                Helper.Amount(0)
                              : val === "Payments Applied"
                              ? Helper.Amount(value.PaymentsApplied) ??
                                Helper.Amount(0)
                              : val === "Unapplied Payments"
                              ? Helper.Amount(value.unappliedPayments) ??
                                Helper.Amount(0)
                              : val === "Net Investment"
                              ? Helper.Amount(value.netInvestment) ??
                                Helper.Amount(0)
                              // : val === "Average Lease Term"
                              // ? value.averageLeaseTerm ?? 0
                              : val === "End of Lease Asset Value"
                              ? Helper.Amount(value.endofLeaseAssetValue) ??
                                Helper.Amount(0)
                              : val === "Average Term Original"
                              ? value.averageOriginalTerm ??
                                0
                              : val === "Average Term Remaining"
                              ? value.averageRemainingTerm ??
                                0
                              : ""}
                          </h5>
                          {/* {val === "Unapplied Payments" && (
                            <div
                              style={{
                                marginTop: "10px",
                                color: "#1DBB55",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={handleView}
                            >
                              {/* <a href="/reports/payments-applied" style={{ color: "#1DBB55", textDecoration: "underline" }}> */}
                              {/* View All */}
                              {/* </a> */}
                            {/* </div> */}
                          {/* )} */} 
                           {/* {val === 'Pending Contracts' && (
                              <div style={{ marginTop: '10px', color: "#1DBB55", textDecoration: "underline", cursor: 'pointer' }} onClick={handlePendingView}>
                               View All
                              </div>
                            )} */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="container-fluid">
                <div className="row" id="show_page">
                  {charts &&
                    charts.map((val, index) =>
                      (isContractsChecked &&
                        val.key === "Contracts by Month") ||
                      (isReceiptsChecked && val.key === "Receipts by Month") ||
                      (isDelinquencyAging && val.key === "Delinquency Aging") ||
                      (isleaseRevenueandProfitability &&
                        val.key === "Lease Revenue and Profitability") ||
                      (piechart && val.key === "Asset Concentration") ? (
                        <div
                          className="col-md-6 col-sm-6 mb-xl-0 mb-4"
                          key={val.key}
                          draggable="true"
                          onDragStart={(e) => handleDragStartChart(e, val.key)}
                          onDragOver={(e) => handleDragOverChart(e)}
                          onDrop={(e) => handleDropChart(e, val.key)}
                        >
                          <div className="card" style={{ marginTop: "10px" }}>
                            <div className="card-body">
                              {val.key !== "Delinquency Aging" && val.key !== "Asset Concentration" && (
                                <h5 className="mb-1 tc col-form-label">{val.key}</h5>
                              )}
                              {val.component()}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                </div>
              </div>
              <div className="container-fluid ">
                <div
                  className="accordion mb-4 pt-4 "
                  id="accordionFlushExample"
                >
                  {tableData &&
                    tableData.map((val, index) =>
                      (isPendingcontracts &&
                        val.key === "Pending Contract" &&
                        customerPermission !== "Customer") ||
                      (isinvoicesDue && val.key === "Invoices Due") ||
                      (iscontract && val.key === "Contracts") ||
                      (isUnappliedPayments &&
                        val.key === "Unapplied Payment") ? (
                        <div
                          className="accordion-item"
                          key={val.key}
                          draggable="true"
                          onDragStart={(e) => handleDragStartTable(e, val.key)}
                          onDragOver={(e) => handleDragOverTable(e)}
                          onDrop={(e) => handleDroptable(e, val.key)}
                        >
                          <h2
                            className="accordion-header"
                            id={`panelsStayOpen-heading${index}`}
                          >
                            <button
                              className="accordion-button tc"
                              type="button"
                              style={{ color: "#245C7F" }}
                              data-bs-toggle="collapse"
                              data-bs-target={`#panelsStayOpen-collapse${index}`}
                              aria-expanded={
                                index === val[0] ? "true" : "false"
                              }
                              onClick={() => handleExpanded(val.key)}
                            >
                              <b>{val.key}</b>
                            </button>
                          </h2>
                          <div
                            id={`panelsStayOpen-collapse${index}`}
                            className={`accordion-collapse collapse ${
                              index === 0 ? "show" : ""
                            }`}
                            aria-labelledby={`panelsStayOpen-heading${index}`}
                          >
                            <div className="accordion-body">
                              {val.component()}
                              {val.key === "Pending Contract" &&
                              pendingcon.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={
                                    permissionss &&
                                    permissionsArray.includes(
                                      "change_contract"
                                    ) === true
                                      ? hadnlependingcontract
                                      : ""
                                  }
                                >
                                  {" "}
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : (
                                ""
                              )}
                              {val.key === "Invoices Due" &&
                              invoicess.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={
                                    permissionss &&
                                    permissionsArray.includes(
                                      "view_invoiceheader"
                                    ) === true
                                      ? handleInvoice
                                      : ""
                                  }
                                >
                                  {" "}
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : (
                                ""
                              )}
                              {val.key === "Contracts" &&
                              activecontract.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={
                                    permissionss &&
                                    permissionsArray.includes(
                                      "view_contract"
                                    ) === true
                                      ? hadnlecontract
                                      : ""
                                  }
                                >
                                  {" "}
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : (
                                ""
                              )}
                              {val.key === "Unapplied Payment" &&
                              unappliedreceipt.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={
                                    permissionss &&
                                    permissionsArray.includes(
                                      "view_receipts"
                                    ) === true
                                      ? handleReceipt
                                      : ""
                                  }
                                >
                                  {" "}
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                </div>
              </div>
            </>
          )}
          {selectedDashboard === "Operations" && (
            <div className="container-fluid py-4">
              
              <div className="">
                <div className="">
                  {/* <p>Operations Dashboard Content</p> */}
                  {/* Add Operations-specific content here */}
                  <div className="row" id="show_page" style={{ marginBottom: '-2%' }}>
                    {checkbox.map((val) => (
                      <div
                        key={val}
                        className={`col-xl-${Math.floor(12 / (checkbox.length <= 6 ? checkbox.length : 6))} col-md-4 col-sm-6 mb-4`}
                        draggable="true"
                        onDragStart={(e) => handleDragStart(e, val)}
                        onDragOver={(e) => handleDragOver(e)}
                        onDrop={(e) => handleDrop(e, val)}
                      >
                        <div className="card">
                          <div className="card-body">
                             {val === "Pending Contracts" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontSize: '16px',
                                fontWeight:700,
                              }}
                              onClick={handlePendingView}
                            >
                              Pending Contracts
                            </h5>
                          ) : val === "Unapplied Payments" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '16px'
                              }}
                              onClick={handleView}
                            >
                              Unapplied Payments
                            </h5>
                          ) :
                           val === "Net Investment" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '16px'
                              }}
                              onClick={handleNetinvestmentView}
                            >
                              Net Investment
                            </h5>
                          ) :
                           val === "Average Term Original" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '15px'
                              }}
                              onClick={handleAverageTermOriginal}
                            >
                              Average Term Original (Months)
                            </h5>
                          ) 
                          :
                          val === "Average Term Remaining" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '15px'
                              }}
                              onClick={handleAverageTermRemaining}
                            >
                              Average Term Remaining (Months)
                            </h5>
                          ) 
                          :
                          (
                            <label
                              className="overview"
                              style={{ fontSize: "16px" }}
                            >
                              {val}
                            </label>
                          )}
                            {/* <label className="overview" style={{ fontSize: '16px' }}>{val}</label> */}
                            <h5 style={{ color: "#1DBB55" }}>
                              {(val === 'Amount Financed' || val === 'Payments Applied' || val === 'Unapplied Payments') && '$'}
                              {val === 'Amount Financed' ? (Helper.Amount(value.AmountFinanced) ?? Helper.Amount(0)) :
                                val === 'Pending Contracts' ? (value.PendingContracts ?? 0) :
                                val === 'Amount Due' ? (Helper.Amount(value.AmountDue) ?? Helper.Amount(0)) :
                                val === 'Payments Applied' ? (Helper.Amount(value.PaymentsApplied) ?? Helper.Amount(0)) :
                                val === 'Unapplied Payments' ? (Helper.Amount(value.unappliedPayments) ?? Helper.Amount(0)) :
                                val === 'Net Investment' ? (Helper.Amount(value.netInvestment) ?? Helper.Amount(0)) :
                                // val === 'Average Lease Term' ? (value.averageLeaseTerm ?? 0) :
                                val === 'End of Lease Asset Value' ? (Helper.Amount(value.endofLeaseAssetValue) ?? Helper.Amount(0)) :
                                val === 'Average Term Original' ? (Helper.Amount(value.averageOriginalTerm) ?? 0) :
                                val === 'Average Term Remaining' ? ((value.averageRemainingTerm) ?? 0) :
                                ''}
                            </h5>
                            {/* {val === 'Unapplied Payments' && (
                              <div style={{ marginTop: '10px', color: "#1DBB55", textDecoration: "underline", cursor: 'pointer' }} onClick={handleView}>
                                View All
                              </div>
                            )}
                            {val === 'Pending Contracts' && (
                              <div style={{ marginTop: '10px', color: "#1DBB55", textDecoration: "underline", cursor: 'pointer' }} onClick={handlePendingView}>
                               View All
                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="row mt-3" id="show_page">
                    {charts && charts.map((val, index) =>
                      (isContractsChecked && val.key === 'Contracts by Month') ||
                      (isReceiptsChecked && val.key === 'Receipts by Month') ||
                      (isDelinquencyAging && val.key === 'Delinquency Aging') ||
                      (isleaseRevenueandProfitability && val.key === 'Lease Revenue and Profitability') ||
                      (piechart && val.key === 'Asset Concentration') ? (
                        <div
                          className='col-md-6 col-sm-6 mb-xl-0 mb-4'
                          key={val.key}
                          draggable="true"
                          onDragStart={(e) => handleDragStartChart(e, val.key)}
                          onDragOver={(e) => handleDragOverChart(e)}
                          onDrop={(e) => handleDropChart(e, val.key)}
                        >
                          <div className="card" style={{ marginTop: '10px' }}>
                            <div className="card-body">
                                {val.key !== "Delinquency Aging" && val.key !== "Asset Concentration" && (

                              <h5 className="mb-1 tc col-form-label">{val.key}</h5>
                                )}
                              {val.component()}
                            </div>
                          </div>
                        </div>
                      ) : ''
                    )}
                  </div>
                  <div className="accordion mb-4 pt-4" id="accordionFlushExample">
                    {tableData && tableData.map((val, index) =>
                      (isPendingcontracts && val.key === 'Pending Contract' && customerPermission !== 'Customer') ||
                      (isinvoicesDue && val.key === 'Invoices Due') ||
                      (iscontract && val.key === 'Contracts') ||
                      (isUnappliedPayments && val.key === 'Unapplied Payment') ? (
                        <div
                          className="accordion-item"
                          key={val.key}
                          draggable="true"
                          onDragStart={(e) => handleDragStartTable(e, val.key)}
                          onDragOver={(e) => handleDragOverTable(e)}
                          onDrop={(e) => handleDroptable(e, val.key)}
                        >
                          <h2 className="accordion-header" id={`panelsStayOpen-heading${index}`}>
                            <button
                              className="accordion-button tc"
                              type="button"
                              style={{ color: "#245C7F" }}
                              data-bs-toggle="collapse"
                              data-bs-target={`#panelsStayOpen-collapse${index}`}
                              aria-expanded={index === 0 ? "true" : "false"}
                              onClick={() => handleExpanded(val.key)}
                            >
                              <b>{val.key}</b>
                            </button>
                          </h2>
                          <div
                            id={`panelsStayOpen-collapse${index}`}
                            className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                            aria-labelledby={`panelsStayOpen-heading${index}`}
                          >
                            <div className="accordion-body">
                              {val.component()}
                              {val.key === 'Pending Contract' && pendingcon.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('change_contract') ? hadnlependingcontract : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                              {val.key === 'Invoices Due' && invoicess.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('view_invoiceheader') ? handleInvoice : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                              {val.key === 'Contracts' && activecontract.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('view_contract') ? hadnlecontract : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                              {val.key === 'Unapplied Payment' && unappliedreceipt.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('view_receipts') ? handleReceipt : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                            </div>
                          </div>
                        </div>
                      ) : ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {selectedDashboard === "Finance" && (
             <div className="container-fluid py-4">
              <div className="">
                <div className="">
                  {/* <p>Finance Dashboard Content</p> */}
                  {/* Add Operations-specific content here */}
                  <div className="row" id="show_page" style={{ marginBottom: '-2%' }}>
                    {checkbox.map((val) => (
                      <div
                        key={val}
                        className={`col-xl-${Math.floor(12 / (checkbox.length <= 6 ? checkbox.length : 6))} col-md-4 col-sm-6 mb-4`}
                        draggable="true"
                        onDragStart={(e) => handleDragStart(e, val)}
                        onDragOver={(e) => handleDragOver(e)}
                        onDrop={(e) => handleDrop(e, val)}
                      >
                        <div className="card">
                          <div className="card-body">
                             {val === "Pending Contracts" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontSize: '16px',
                                fontWeight:700,
                              }}
                              onClick={handlePendingView}
                            >
                              Pending Contracts
                            </h5>
                          ) : val === "Unapplied Payments" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '16px'
                              }}
                              onClick={handleView}
                            >
                              Unapplied Payments
                            </h5>
                          ) : 
                           val === "Net Investment" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '16px'
                              }}
                              onClick={handleNetinvestmentView}
                            >
                              Net Investment
                            </h5>
                          ) :
                           val === "Average Term Original" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '15px'
                              }}
                              onClick={handleAverageTermOriginal}
                            >
                              Average Term Original (Months)
                            </h5>
                          ) 
                          :
                          val === "Average Term Remaining" ? (
                            <h5
                              className="overview"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                // color: "#245C7F",
                                fontWeight:700,
                                fontSize: '15px'
                              }}
                              onClick={handleAverageTermRemaining}
                            >
                              Average Term Remaining (Months)
                            </h5>
                          ) 
                          :
                          (
                            <label
                              className="overview"
                              style={{ fontSize: "16px" }}
                            >
                              {val}
                            </label>
                          )}
                            {/* <label className="overview" style={{ fontSize: '16px' }}>{val}</label> */}
                            <h5 style={{ color: "#1DBB55" }}>
                              {(val === 'Amount Financed' || val === 'Payments Applied' || val === 'Unapplied Payments') && '$'}
                              {val === 'Amount Financed' ? (Helper.Amount(value.AmountFinanced) ?? Helper.Amount(0)) :
                                val === 'Pending Contracts' ? (value.PendingContracts ?? 0) :
                                val === 'Amount Due' ? (Helper.Amount(value.AmountDue) ?? Helper.Amount(0)) :
                                val === 'Payments Applied' ? (Helper.Amount(value.PaymentsApplied) ?? Helper.Amount(0)) :
                                val === 'Unapplied Payments' ? (Helper.Amount(value.unappliedPayments) ?? Helper.Amount(0)) :
                                val === 'Net Investment' ? (Helper.Amount(value.netInvestment) ?? Helper.Amount(0)) :
                                // val === 'Average Lease Term' ? (value.averageLeaseTerm ?? 0) :
                                val === 'End of Lease Asset Value' ? (Helper.Amount(value.endofLeaseAssetValue) ?? Helper.Amount(0)) :
                                val === 'Average Term Original' ? (Helper.Amount(value.averageOriginalTerm) ?? 0) :
                                val === 'Average Term Remaining' ? ((value.averageRemainingTerm) ?? 0) :
                                ''}
                            </h5>
                            {/* {val === 'Unapplied Payments' && (
                              <div style={{ marginTop: '10px', color: "#1DBB55", textDecoration: "underline", cursor: 'pointer' }} onClick={handleView}>
                                View All
                              </div>
                            )}
                             {val === 'Pending Contracts' && (
                              <div style={{ marginTop: '10px', color: "#1DBB55", textDecoration: "underline", cursor: 'pointer' }} onClick={handlePendingView}>
                               View All
                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="row mt-3" id="show_page">
                    {charts && charts.map((val, index) =>
                      (isContractsChecked && val.key === 'Contracts by Month') ||
                      (isReceiptsChecked && val.key === 'Receipts by Month') ||
                      (isDelinquencyAging && val.key === 'Delinquency Aging') ||
                      (isleaseRevenueandProfitability && val.key === 'Lease Revenue and Profitability') ||
                      (piechart && val.key === 'Asset Concentration') ? (
                        <div
                          className='col-md-6 col-sm-6 mb-xl-0 mb-4'
                          key={val.key}
                          draggable="true"
                          onDragStart={(e) => handleDragStartChart(e, val.key)}
                          onDragOver={(e) => handleDragOverChart(e)}
                          onDrop={(e) => handleDropChart(e, val.key)}
                        >
                          <div className="card" style={{ marginTop: '10px' }}>
                            <div className="card-body">
                              {val.key !== "Delinquency Aging" && val.key !== "Asset Concentration" && (

                              <h5 className="mb-1 tc col-form-label">{val.key}</h5>
                              )}
                              {val.component()}
                            </div>
                          </div>
                        </div>
                      ) : ''
                    )}
                  </div>
                  <div className="accordion mb-4 pt-4" id="accordionFlushExample">
                    {tableData && tableData.map((val, index) =>
                      (isPendingcontracts && val.key === 'Pending Contract' && customerPermission !== 'Customer') ||
                      (isinvoicesDue && val.key === 'Invoices Due') ||
                      (iscontract && val.key === 'Contracts') ||
                      (isUnappliedPayments && val.key === 'Unapplied Payment') ? (
                        <div
                          className="accordion-item"
                          key={val.key}
                          draggable="true"
                          onDragStart={(e) => handleDragStartTable(e, val.key)}
                          onDragOver={(e) => handleDragOverTable(e)}
                          onDrop={(e) => handleDroptable(e, val.key)}
                        >
                          <h2 className="accordion-header" id={`panelsStayOpen-heading${index}`}>
                            <button
                              className="accordion-button tc"
                              type="button"
                              style={{ color: "#245C7F" }}
                              data-bs-toggle="collapse"
                              data-bs-target={`#panelsStayOpen-collapse${index}`}
                              aria-expanded={index === 0 ? "true" : "false"}
                              onClick={() => handleExpanded(val.key)}
                            >
                              <b>{val.key}</b>
                            </button>
                          </h2>
                          <div
                            id={`panelsStayOpen-collapse${index}`}
                            className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                            aria-labelledby={`panelsStayOpen-heading${index}`}
                          >
                            <div className="accordion-body">
                              {val.component()}
                              {val.key === 'Pending Contract' && pendingcon.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('change_contract') ? hadnlependingcontract : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                              {val.key === 'Invoices Due' && invoicess.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('view_invoiceheader') ? handleInvoice : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                              {val.key === 'Contracts' && activecontract.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('view_contract') ? hadnlecontract : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                              {val.key === 'Unapplied Payment' && unappliedreceipt.length >= 5 ? (
                                <span
                                  className="hyperlink"
                                  onClick={permissionss && permissionsArray.includes('view_receipts') ? handleReceipt : ""}
                                >
                                  Upto 5 displayed. For more details click here.
                                </span>
                              ) : ''}
                            </div>
                          </div>
                        </div>
                      ) : ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <ContentLoader
          className="pt-3"
          viewBox="0 0 1200 900"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="68" y="37" rx="3" ry="3" width="298" height="129" />
          <rect x="426" y="37" rx="3" ry="3" width="298" height="129" />
          <rect x="786" y="37" rx="3" ry="3" width="298" height="129" />
          <rect x="68" y="217" rx="3" ry="3" width="535" height="42" />
          <rect x="68" y="308" rx="3" ry="3" width="1018" height="17" />
          <circle cx="951" cy="386" r="11" />
          <circle cx="986" cy="386" r="11" />
          <rect x="176" y="378" rx="3" ry="3" width="141" height="15" />
          <rect x="377" y="377" rx="3" ry="3" width="299" height="15" />
          <rect x="733" y="377" rx="3" ry="3" width="141" height="15" />
          <rect x="68" y="418" rx="3" ry="3" width="1018" height="2" />
          <circle cx="952" cy="447" r="11" />
          <circle cx="987" cy="447" r="11" />
          <rect x="177" y="439" rx="3" ry="3" width="141" height="15" />
          <rect x="378" y="438" rx="3" ry="3" width="299" height="15" />
          <rect x="734" y="438" rx="3" ry="3" width="141" height="15" />
          <rect x="68" y="479" rx="3" ry="3" width="1018" height="2" />
          <circle cx="953" cy="505" r="11" />
          <circle cx="988" cy="505" r="11" />
          <rect x="178" y="497" rx="3" ry="3" width="141" height="15" />
          <rect x="379" y="496" rx="3" ry="3" width="299" height="15" />
          <rect x="735" y="496" rx="3" ry="3" width="141" height="15" />
          <rect x="68" y="537" rx="3" ry="3" width="1018" height="2" />
          <circle cx="954" cy="566" r="11" />
          <circle cx="989" cy="566" r="11" />
          <rect x="179" y="558" rx="3" ry="3" width="141" height="15" />
          <rect x="380" y="557" rx="3" ry="3" width="299" height="15" />
          <rect x="736" y="557" rx="3" ry="3" width="141" height="15" />
          <rect x="68" y="598" rx="3" ry="3" width="1018" height="2" />
          <circle cx="953" cy="626" r="11" />
          <circle cx="988" cy="626" r="11" />
          <rect x="178" y="618" rx="3" ry="3" width="141" height="15" />
          <rect x="379" y="617" rx="3" ry="3" width="299" height="15" />
          <rect x="735" y="617" rx="3" ry="3" width="141" height="15" />
          <rect x="68" y="658" rx="3" ry="3" width="1018" height="2" />
          <circle cx="954" cy="687" r="11" />
          <circle cx="989" cy="687" r="11" />
          <rect x="179" y="679" rx="3" ry="3" width="141" height="15" />
          <rect x="380" y="678" rx="3" ry="3" width="299" height="15" />
          <rect x="736" y="678" rx="3" ry="3" width="141" height="15" />
          <rect x="68" y="716" rx="3" ry="3" width="1018" height="2" />
          <rect x="68" y="312" rx="3" ry="3" width="2" height="465" />
          <rect x="1085" y="312" rx="3" ry="3" width="2" height="465" />
          <circle cx="954" cy="747" r="11" />
          <circle cx="989" cy="747" r="11" />
          <rect x="179" y="739" rx="3" ry="3" width="141" height="15" />
          <rect x="380" y="738" rx="3" ry="3" width="299" height="15" />
          <rect x="736" y="738" rx="3" ry="3" width="141" height="15" />
          <rect x="68" y="776" rx="3" ry="3" width="1018" height="2" />
          <rect x="68" y="343" rx="3" ry="3" width="1018" height="17" />
          <rect x="68" y="320" rx="3" ry="3" width="68" height="33" />
          <rect x="294" y="317" rx="3" ry="3" width="149" height="33" />
          <rect x="588" y="318" rx="3" ry="3" width="122" height="33" />
          <rect x="854" y="319" rx="3" ry="3" width="72" height="33" />
          <rect x="1064" y="317" rx="3" ry="3" width="22" height="33" />
          <rect x="634" y="217" rx="0" ry="0" width="450" height="40" />
          <circle cx="802" cy="237" r="20" />
        </ContentLoader>
      )}
    </>
  );
}

export default Dashboard;
